<template>
  <a-config-provider :locale="locale">
    <router-view />
  </a-config-provider>
</template>

<script lang="ts" setup>
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import { ref } from 'vue';

dayjs.locale('zh-cn');
const locale = ref(zhCN);
</script>

<style lang="scss">
html {
  width: 100%;
  height: 100%;
  overflow: hidden;

  body {
    width: 100%;
    height: 100%;

    #app {
      width: 100%;
      height: 100%;

      color: $color-content-text;
      font-size: $font-size;
    }
  }

  body {
    --sb-track-color: #cacaca66;
    --sb-thumb-color: #3db389;
    --sb-size: 5px;
  }

  ul::-webkit-scrollbar,
  div::-webkit-scrollbar {
    width: var(--sb-size);
    height: var(--sb-size);
  }

  ul::-webkit-scrollbar-track,
  div::-webkit-scrollbar-track {
    background: var(--sb-track-color);
    border-radius: 3px;
  }

  ul::-webkit-scrollbar-thumb,
  div::-webkit-scrollbar-thumb {
    background: var(--sb-thumb-color);
    border-radius: 3px;
  }

  @supports not selector(::-webkit-scrollbar) {
    div {
      scrollbar-color: var(--sb-thumb-color) var(--sb-track-color);
    }
  }
}
</style>
